import { TextButtonLarge } from '@components/core-ui/form-elements/buttons/Button/variations/TextButtonLarge';
import InlineAttentionIcon from '@components/icons/InlineAttention.svg';

type TProps = {
  onRetry: () => void;
};

export const ErrorCard = ({ onRetry }: TProps) => (
  <div
    className="relative flex min-h-[220px] w-[260px] min-w-[230px] flex-col rounded-[10px] border border-[var(--color-border)]"
    role="alert"
  >
    <div className="px-5 pb-[60px] pt-5">
      <h2 className="text-lg font-medium leading-[1.5] text-[var(--color-text-muted)]">AutoScriptOne</h2>
      <p className="mt-3 flex items-center gap-2 text-lg font-semibold leading-[1.5] text-[var(--color-error-heading)]">
        <InlineAttentionIcon aria-hidden="true" className="h-[18px] w-[18px] shrink-0" focusable="false" />
        <span>Couldn&apos;t load</span>
      </p>
      <p className="mt-1.5 text-xs leading-[1.3] text-[var(--color-text-subtle)]">
        Your subscription details are unavailable right now.
      </p>
    </div>
    <div className="absolute inset-x-5 bottom-0 h-10 border-t border-[var(--color-border)]">
      <TextButtonLarge className="h-9 w-full rounded-[10px] p-0" onClick={onRetry}>
        Retry
      </TextButtonLarge>
    </div>
  </div>
);
